const AdaptiveEventImage = ({ src, alt, height, containerHeightClass, width, className, loading, fetchPriority }) => {
  const effectiveClassName = className || 'event-image';
  const containerClasses = `event-image-container rounded aspect-video ${containerHeightClass || 'h-[300px]'}`

  return (
    <div className={containerClasses}>
      <div className='blurred-background' style={{
        backgroundImage: `url(${src})`
        }}
       />
      <img
        src={src}
        className={effectiveClassName}
        alt={alt}
        height={height}
        width={width}
        loading={loading}
        fetchpriority={fetchPriority}
      />
    </div>
  )
}

export default AdaptiveEventImage;
